var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 65.744,
    viewBox: "0 0 106 65.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160587",
    "data-name": "Group 160587",
    transform: "translate(-29 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160433",
    "data-name": "Group 160433",
    transform: "translate(29 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(59.352 23.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M375.418,173.587c0-3.484-2.417-6.041-6.322-6.041H360.33v18.741h7.014v-6.658h-.1l3.681,6.658h4.608l-4.243-7.137a5.418,5.418,0,0,0,4.132-5.563",
    transform: "translate(-360.33 -167.546)",
    fill: "#efab4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M268.335,169.167h-14.2v10.985c0,4.53,2.691,7.66,8.267,7.66s8.265-3.13,8.265-7.66V169.167Z",
    transform: "translate(-214.597 -145.496)",
    fill: "#f08089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M146.412,167.546a9.475,9.475,0,1,0,9.558,9.473,9.2,9.2,0,0,0-9.558-9.473",
    transform: "translate(-119.172 -144.177)",
    fill: "#76578f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M42.184,169.167l7.03,10.819v7.5h3.9v-7.5l7-10.819Z",
    transform: "translate(-42.184 -145.496)",
    fill: "#576298"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 47.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M54.21,303.307a4.507,4.507,0,0,1,3.6,4.579c0,2.839-1.853,5.086-5.451,5.086H42.184V294.232h9.861c3.57,0,5.4,2.274,5.4,4.775a4.186,4.186,0,0,1-3.231,4.3",
    transform: "translate(-42.184 -294.232)",
    fill: "#90bf5c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M234.761,294.227l-7.223,18.741h19.446l-7.223-18.741Z",
    transform: "translate(-192.959 -247.225)",
    fill: "#4694ae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(18.265 47.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M155.176,300.268c0-3.484-2.417-6.041-6.322-6.041h-8.766v18.741H147.1v-6.658H147l3.682,6.658h4.608l-4.243-7.137a5.418,5.418,0,0,0,4.132-5.563",
    transform: "translate(-140.088 -294.226)",
    fill: "#e1d159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(19.304 0.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M160.747,48.722c0-3.484-2.417-6.041-6.322-6.041h-8.766V61.422h7.014V54.764h-.1l3.682,6.658h4.608l-4.243-7.137a5.418,5.418,0,0,0,4.131-5.563",
    transform: "translate(-145.659 -42.681)",
    fill: "#efab4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M42.184,61.38v-18.7h10.6c3.7,0,5.467,2.411,5.467,4.766a4.177,4.177,0,0,1-3.2,4.289,4.478,4.478,0,0,1,3.56,4.57c0,2.719-1.822,5.074-5.495,5.074Z",
    transform: "translate(-42.184 -42.607)",
    fill: "#f08089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M255.554,61.379H241.22v-18.7h14.334v4.065h-3.874v3.112h3.874V53.95h-3.874v3.364h3.874Z",
    transform: "translate(-204.089 -42.606)",
    fill: "#e1d159"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(54.127 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M356.206,53.282,352.3,61.125l-5.323-10.688-.021-.043-5.275,10.678-.047-.1-9.31-18.694H351.4Z",
    transform: "translate(-332.323 -42.283)",
    fill: "#4694ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M457.193,42.283h6.065l-2.752,5.526-.477.958Z",
    transform: "translate(-433.898 -42.283)",
    fill: "#4694ae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M467.161,303.583c0,5.677-4.074,9.385-9.918,9.385h-6.591l8.136-8.136v4.3h2.389v-8.382h-8.382v2.388h4.3l-7.273,7.273v-16.19h7.389C463.087,294.227,467.161,297.963,467.161,303.583Z",
    transform: "translate(-373.777 -247.225)",
    fill: "#76578f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M356.808,294.226h-2.115v4.518l-4.518-4.518h-6.152v18.741h6.106v-4.438l4.438,4.438H360.8V294.226Z",
    transform: "translate(-287.712 -247.224)",
    fill: "#576298"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160564",
    "data-name": "Group 160564",
    transform: "translate(123.793 74.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37585",
    "data-name": "Path 37585",
    d: "M357.027.971H355.14V.29h4.534V.971h-1.887V5.777h-.778V.971Z",
    transform: "translate(-355.14 -0.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37586",
    "data-name": "Path 37586",
    d: "M362.988,5.777V1.769L361,5.1h-.35l-1.985-3.308V5.757h-.759V.29h.642l2.277,3.852L363.086.29h.642V5.777Z",
    transform: "translate(-352.521 -0.29)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fda47fb460c41be2510b2753e3369f52.svg";
export { ForwardRef as ReactComponent };